const CLAIM = {
  FIRST_LOGIN_CLAIM: 'https://www.studywithnewzealand.govt.nz/first_login',
}

export default CLAIM
